export const GETDATA_INIT = 'GETDATA_INIT';
export const GETDATA_SUCCESS = 'GETDATA_SUCCESS';
export const GETDATA_FAIL = 'GETDATA_FAIL';

export const GETSTORE_INIT = 'GETSTORE_INIT';
export const GETSTORE_SUCCESS = 'GETSTORE_SUCCESS';
export const GETSTORE_FAIL = 'GETSTORE_FAIL';
